import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { DateProvider } from '../../../providers';
import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import {
  Container,
  FlagImage,
  PointsAway,
  PointsHome,
  TeamColor,
  TeamName,
  Timer,
} from './styles';

function SoccerWorldCup2022Official({ data }) {
  const { awayTeam, homeTeam, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '00:00';
    const [minutes, seconds] = DateProvider.getSoccerTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <FontFamilyHeader family={FONT_FAMILY['qatar2022']} />
      <Container>
        <Timer>{getTime()}</Timer>
        <FlagImage alt="Home Team" src={homeTeam.image} />
        <TeamColor
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.428 30.749C10.0919 26.0822 6.79161 22.829 2.15449 16.4867C7.32346 10.3192 10.6198 6.98971 16.4774 2.15413C22.7699 6.82231 25.9159 10.2395 30.7415 16.4519C26.0657 22.6185 22.7323 25.8649 16.428 30.749Z"
            fill={homeTeam?.colors?.[0]?.value}
            stroke="white"
            stroke-width="2"
          />
        </TeamColor>
        <TeamName>{homeTeam.name}</TeamName>
        <PointsHome>{homeTeam.points}</PointsHome>
        <svg
          width="207"
          height="64"
          viewBox="0 0 207 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1919_3066)">
            <rect x="14" y="3" width="178" height="56" fill="white" />
            <path
              d="M91 17H65V48.5H91V61L104 50.5L116.5 61V48.5H142V17H116.5V2L104 11L91 2V17Z"
              stroke="#B2A98B"
              stroke-width="3"
            />
            <rect
              x="13"
              y="2"
              width="180"
              height="60"
              stroke="#50121D"
              stroke-width="4"
            />
            <path
              d="M144.628 6C132.447 16.135 127.125 22.7111 119 32C129.312 45.6114 134.834 50.5345 144.628 58H186.848H207V6H144.628Z"
              fill="#82182E"
            />
            <path
              d="M63.3717 58C75.5527 47.865 80.8749 41.2889 89 32C78.6876 18.3886 73.1659 13.4655 63.3717 6L21.1518 6H0L0 58L63.3717 58Z"
              fill="#82182E"
            />
            <path
              d="M111 32C108.457 28.6064 106.917 27.1111 104 25C101.007 27.3318 99.4641 28.8388 97 32C99.3396 34.9829 100.834 36.5399 104 39C106.885 36.5215 108.431 34.9967 111 32Z"
              fill="#82182E"
            />
          </g>
          <defs>
            <clipPath id="clip0_1919_3066">
              <rect width="207" height="64" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <PointsAway>{awayTeam.points}</PointsAway>
        <TeamName>{awayTeam.name}</TeamName>
        <TeamColor
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.428 30.749C10.0919 26.0822 6.79161 22.829 2.15449 16.4867C7.32346 10.3192 10.6198 6.98971 16.4774 2.15413C22.7699 6.82231 25.9159 10.2395 30.7415 16.4519C26.0657 22.6185 22.7323 25.8649 16.428 30.749Z"
            fill={awayTeam?.colors?.[0]?.value}
            stroke="white"
            stroke-width="2"
          />
        </TeamColor>
        <FlagImage alt="Away Team" src={awayTeam.image} />
      </Container>
    </>
  );
}

SoccerWorldCup2022Official.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

SoccerWorldCup2022Official.defaultProps = {
  data: {
    awayTeam: {
      colors: ['#74ACDF'],
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Argentina.svg/1200px-Flag_of_Argentina.svg.png',
      name: 'ARG',
      points: 1,
    },
    homeTeam: {
      colors: ['#E50A38'],
      image:
        'https://www.banderasphonline.com/wp-content/uploads/2021/08/comprar-bandera-espana-sin-escudo-para-exterior-interior-1200x900.png',
      name: 'ESP',
      points: 0,
    },
    status: 'paused',
    time: [],
  },
  styles: {},
};

export default SoccerWorldCup2022Official;
